import fetchRequest from "./fetchRequest";

export const request = {
  async get(url) {
    try {
      const resp = await fetchRequest(url, {headers: {'Content-Type': 'application/json'}});
  
      if (!resp.ok) {
        throw new Error("Invalid response");
      }
  
      const jsonResp = await resp.json();
  
      return {data: jsonResp};
    } catch(err) {
      return Promise.reject(err);
    }
  },
  async post(url, body) {
    try {
      const resp = await fetchRequest(url, {method: 'POST', body: JSON.stringify(body), headers: {'Content-Type': 'application/json'}});
  
      if (!resp.ok) {
        throw new Error("Invalid response");
      }
  
      const jsonResp = await resp.json();
  
      return {data: jsonResp};
    } catch(err) {
      return Promise.reject(err);
    }
  }
};

export function checkSupporter(supporter_number, zip_code, wp_nonce) {
  return request.get(`api/wvus/create_account/check_supporter?supporter_number=${supporter_number}&zip_code=${zip_code}&_wpnonce=${wp_nonce}`);
}

export function checkUserName(email, wp_nonce) {
  return request.get(`api/wvus/create_account/check_username?email=${email}&_wpnonce=${wp_nonce}`);
}
  
export function createCiamUserBySupporterNumber( supporter_number, email, password, wp_nonce ) {
  return request.post("api/wvus/create_account/create_ciam_user_by_supporter_number", {
    supporter_number,
    email,
    password,
    _wpnonce: wp_nonce
  });
}

export function createCiamUser(email, password, wp_nonce) {
  return request.post("api/wvus/create_account/create_ciam_user", {
    email,
    password,
    _wpnonce: wp_nonce
  });
}

